<template>
    <div class="main-container"> 
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'main-container'
}
</script>

<style lang="scss" scoped>
.main-container {
    width: calc(100vw - 270px);
    padding: 5px 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16); 
    height: calc(100vh - 110px);

    &_p20 {
        padding: 5px 20px;
    }
}

@media only screen and (max-width: 768px) {
    .main-container {
        width: calc(100vw - 40px);
    }
}

@media only screen and (max-width: 568px) {
    .main-container {
        width: calc(100vw - 20px);
    }
}
</style>